import VueRouter from "vue-router";
import { setPageTitle } from "@/helpers/pageTitle";

// Layout
const BaseLayout = () => import("@/views/_layouts/BaseLayout");

// Common Pages
const Comingsoon = () => import("@/views/_general/Comingsoon");
const Error404 = () => import("@/views/_general/404");
const ForgotPassword = () => import("@/views/_general/ForgotPassword");
const VerifyEmail = () => import("@/views/_general/VerifyEmail");
const Login = () => import("@/views/_general/Login");
const ResetPassword = () => import("@/views/_general/ResetPassword");

// Pages
const AuthProfile = () => import("@/views/_auth/AuthProfile");

const Home = () => import("@/views/_general/Home");

const UserList = () => import("@/views/Users/UserList");
const UserProfile = () => import("@/views/Users/UserProfile");

const SupportiveSingle = () => import("@/views/Supports/SupportiveSingle");

const AuditTrailList = () => import("@/views/AuditTrails/AuditTrailList");
const AuditTrailProfile = () => import("@/views/AuditTrails/AuditTrailProfile");

const AnnouncementList = () => import("@/views/Announcements/AnnouncementList");

const AdvertisementList = () => import("@/views/Advertisements/AdvertisementList");

const SettingPage = () => import("@/views/SystemVariables/SettingPage");
const SecuritySettingPage = () => import("@/views/SystemVariables/SecuritySettingPage");

const BroadcastList = () => import("@/views/Broadcasts/BroadcastList");

const HeroList = () => import("@/views/Heroes/HeroList");
const HeroProfile = () => import("@/views/Heroes/HeroProfile");

const CreepList = () => import("@/views/Creeps/CreepList");
const CreepProfile = () => import("@/views/Creeps/CreepProfile");

const SagaList = () => import("@/views/Sagas/SagaList");
const SagaProfile = () => import("@/views/Sagas/SagaProfile");

const SagaLevelProfile = () => import("@/views/SagaLevels/SagaLevelProfile");
const SagaStatProfile = () => import("@/views/SagaStats/SagaStatProfile");

const EndlessLevelList = () => import("@/views/EndlessLevels/EndlessLevelList");
const EndlessLevelProfile = () => import("@/views/EndlessLevels/EndlessLevelProfile");

const FarmingLevelList = () => import("@/views/FarmingLevels/FarmingLevelList");
const FarmingLevelProfile = () => import("@/views/FarmingLevels/FarmingLevelProfile");

const FarmingLevelDifficultyProfile = () => import("@/views/FarmingLevelDifficulties/FarmingLevelDifficultyProfile");

const FarmingSkillElementList = () => import("@/views/FarmingSkillElements/FarmingSkillElementList");
const FarmingSkillElementProfile = () => import("@/views/FarmingSkillElements/FarmingSkillElementProfile");

const MapList = () => import("@/views/Maps/MapList");

const QuestList = () => import("@/views/Quests/QuestList");

const WinConditionList = () => import("@/views/WinConditions/WinConditionList");

const GachaGroup = () => import("@/views/GachaGroups/GachaGroupList");
const Gacha = () => import("@/views/Gacha/GachaList");
const GachaProfile = () => import("@/views/Gacha/GachaProfile");

const GachaGroupProfile = () => import("@/views/GachaGroups/GachaGroupProfile");

const GlobalSetting = () => import("@/views/SystemVariables/GlobalSetting");

const MailList = () => import("@/views/Mails/MailList");
const UserInventoryList = () => import("@/views/UserInventories/UserInventoryList");
const EquipmentTierList = () => import("@/views/EquipmentTiers/EquipmentTierList");
const EquipmentRarityList = () => import("@/views/EquipmentRarities/EquipmentRarityList");
const EquipmentSetList = () => import("@/views/EquipmentSets/EquipmentSetList");
const EquipmentConfigPage = () => import("@/views/EquipmentConfig/EquipmentConfigPage");
const HeroEquipmentPage = () => import("@/views/HeroEquipment/HeroEquipmentPage");
const StatDefinitionList = () => import("@/views/StatDefinitions/StatDefinitionList");




// Routes
// ** for more information, kindy refer to https://github.com/websanova/vue-auth/blob/master/docs/Privileges.md
// ** auth: true <- can be access only if auth.check = true
// ** auth: false <- cannot be access is auth.check = true
// ** auth: null, title: '' <- no auth rule
// ** auth: [1,2] <- can be access is auth.user.role matched

const baseLayoutRoutes = [
	{
		path: "/comingsoon",
		name: "admin.home2",
		component: Comingsoon,
		meta: { auth: true, role: [1, 2], title: "Coming Soon" },
	},
	{
		path: "/home",
		name: "home",
		component: Home,
		meta: { auth: true, role: [1, 2], title: "Home" },
	},

	// user
	{
		path: "/user/list",
		name: "user.list",
		component: UserList,
		meta: { auth: true, role: [1], title: "User List" },
	},
	{
		path: "/my/profile",
		name: "my.profile",
		component: AuthProfile,
		meta: { auth: true, role: [1, 2], title: "Profile" },
	},
	{
		path: "/user/profile/:id",
		name: "user.profile",
		component: UserProfile,
		meta: { auth: true, role: [1], title: "User Profile" },
	},
	{
		path: "/user/profile",
		name: "user.my-profile",
		component: UserProfile,
		meta: { auth: true, role: [1], title: "My Profile" },
	},

	// support
	{
		path: "/support/terms-of-use",
		name: "support.terms-of-use",
		component: SupportiveSingle,
		meta: {
			auth: true,
			role: [1],
			title: "T&C",
			params: { type: "terms-of-use" },
		},
	},
	{
		path: "/support/privacy-policy",
		name: "support.privacy-policy",
		component: SupportiveSingle,
		meta: {
			auth: true,
			role: [1],
			title: "T&C",
			params: { type: "privacy-policy" },
		},
	},
	{
		path: "/support/withdrawal-tnc",
		name: "support.withdrawal-tnc",
		component: SupportiveSingle,
		meta: {
			auth: true,
			role: [1],
			title: "Arbitrage Policy Update",
			params: { type: "withdrawal-tnc" },
		},
	},

	//audit trails
	{
		path: "/audit-trail/list",
		name: "audit-trail.list",
		component: AuditTrailList,
		meta: { auth: true, role: [1], title: "Audit Trail List" },
	},
	{
		path: "/audit-trail/profile/:id",
		name: "audit-trail.profile",
		component: AuditTrailProfile,
		meta: { auth: true, role: [1], title: "Audit Trail Profile" },
	},

	{
		path: "/announcement/list",
		name: "announcement.list",
		component: AnnouncementList,
		meta: { auth: true, role: [1], title: "Announcement List" },
	},

	{
		path: "/advertisement/list",
		name: "advertisement.list",
		component: AdvertisementList,
		meta: { auth: true, role: [1], title: "Advertisement List" },
	},

	{
		path: "/setting",
		name: "setting.page",
		component: SettingPage,
		meta: {
			auth: true,
			title: "Settings",
			role: [1],
			page_category: "setting",
		},
	},

	{
		path: "/security-setting",
		name: "security-setting.page",
		component: SecuritySettingPage,
		meta: {
			auth: true,
			title: "Security Settings",
			role: [1],
			page_category: "security-setting",
		},
	},

	// broadcast
	{
		path: "/broadcast/list",
		name: "broadcast.list",
		component: BroadcastList,
		meta: { auth: true, role: [1], title: "Broadcast list" },
	},

	//hero
	{
		path: "/hero/list",
		name: "hero.list",
		component: HeroList,
		meta: { auth: true, role: [1], title: "Hero List" },
	},
	{
		path: "/hero/profile/:id",
		name: "hero.profile",
		component: HeroProfile,
		meta: { auth: true, role: [1], title: "Hero Profile" },
	},

	//creep
	{
		path: "/creep/list",
		name: "creep.list",
		component: CreepList,
		meta: { auth: true, role: [1], title: "Creep List" },
	},
	{
		path: "/creep/profile/:id",
		name: "creep.profile",
		component: CreepProfile,
		meta: { auth: true, role: [1], title: "Creep Profile" },
	},

	//saga
	{
		path: "/saga/list",
		name: "saga.list",
		component: SagaList,
		meta: { auth: true, role: [1], title: "Saga List" },
	},
	{
		path: "/saga/profile/:id",
		name: "saga.profile",
		component: SagaProfile,
		meta: { auth: true, role: [1], title: "Saga Profile" },
	},

	//saga level
	{
		path: "/saga-level/profile/:id",
		name: "saga-level.profile",
		component: SagaLevelProfile,
		meta: { auth: true, role: [1], title: "Saga Level Profile" },
	},
	{
		path: "/saga-stat/profile/:id",
		name: "saga-stat.profile",
		component: SagaStatProfile,
		meta: { auth: true, role: [1], title: "Saga Level Stat Profile" },
	},

	//endless
	{
		path: "/endless/list",
		name: "endless.list",
		component: EndlessLevelList,
		meta: { auth: true, role: [1], title: "Endless List" },
	},
	{
		path: "/endless/profile/:id",
		name: "endless.profile",
		component: EndlessLevelProfile,
		meta: { auth: true, role: [1], title: "Endless Profile" },
	},

	//farming
	{
		path: "/farming/list",
		name: "farming.list",
		component: FarmingLevelList,
		meta: { auth: true, role: [1], title: "Farming List" },
	},
	{
		path: "/farming/profile/:id",
		name: "farming.profile",
		component: FarmingLevelProfile,
		meta: { auth: true, role: [1], title: "Farming Profile" },
	},

	//farming-difficulty
	{
		path: "/farming-difficulty/profile/:id",
		name: "farming-difficulty.profile",
		component: FarmingLevelDifficultyProfile,
		meta: { auth: true, role: [1], title: "Farming Level Difficulty Profile" },
	},

	//farming-skill-element
	{
		path: "/farming-skill-element/list/:farming_level_id",
		name: "farming-skill-element.list",
		component: FarmingSkillElementList,
		meta: { auth: true, role: [1], title: "Farming Skill Elements" },
	},
	{
		path: "/farming-skill-element/profile/:id",
		name: "farming-skill-element.profile",
		component: FarmingSkillElementProfile,
		meta: { auth: true, role: [1], title: "Farming Skill Element Profile" },
	},

	//map
	{
		path: "/map/list",
		name: "map.list",
		component: MapList,
		meta: { auth: true, role: [1], title: "Map List" },
	},

	//quest
	{
		path: "/quest/list",
		name: "quest.list",
		component: QuestList,
		meta: { auth: true, role: [1], title: "Quest List" },
	},

	//win-condition
	{
		path: "/win-condition/list",
		name: "win-condition.list",
		component: WinConditionList,
		meta: { auth: true, role: [1], title: "Win Condition List" },
	},

	//gacha 
	{
		path: '/gacha-group/list',
		name: 'GachaGroup',
		component: GachaGroup, // Create this file if it doesn't exist
		meta: { auth: true, role: [1], title: "Gacha group list" },
	},
	{
		path: "/gacha-group/profile/:id",
		name: "gacha-group.profile",
		component: GachaGroupProfile,
		meta: { auth: true, role: [1], title: "Gacha Group Profile" },
	},
	{
		path: '/gacha/list',
		name: 'Gacha',
		component: Gacha, // Create this file if it doesn't exist
		meta: { auth: true, role: [1], title: "Gacha list" },
	},
	{
		path: "/gacha/profile/:id",
		name: "gacha.profile",
		component: GachaProfile,
		meta: { auth: true, role: [1], title: "Gacha Profile" },
	},
	{
		path: "/global/setting",
		name: "GlobalSetting",
		component: GlobalSetting,
		meta: { auth: true, role: [1], title: "Global Setting" },
	},

	// mail
	{
		path: "/mail/list",
		name: "mail.list",
		component: MailList,
		meta: { auth: true, role: [1], title: "Mail" },
	},

	// inventory
	{
		path: "/inventory/list",
		name: "inventory.list",
		component: UserInventoryList,
		meta: { auth: true, role: [1], title: "User Inventory" },
	},

	// equipment
	{
		path: "/hero-equipment",
		name: "hero-equipment",
		component: HeroEquipmentPage,
		meta: { auth: true, role: [1], title: "Hero Equipment" },
	},
	// legacy equipment routes (kept for direct access if needed)
	{
		path: "/equipment-tier/list",
		name: "equipment-tier.list",
		component: EquipmentTierList,
		meta: { auth: true, role: [1], title: "Equipment Tiers" },
	},
	{
		path: "/equipment-rarity/list",
		name: "equipment-rarity.list",
		component: EquipmentRarityList,
		meta: { auth: true, role: [1], title: "Equipment Rarities" },
	},
	{
		path: "/equipment-set/list",
		name: "equipment-set.list",
		component: EquipmentSetList,
		meta: { auth: true, role: [1], title: "Equipment Sets" },
	},
	{
		path: "/equipment/config",
		name: "equipment.config",
		component: EquipmentConfigPage,
		meta: { auth: true, role: [1], title: "Equipment Config" },
	},
	{
		path: "/stat-definitions",
		name: "stat-definitions",
		component: StatDefinitionList,
		meta: { auth: true, role: [1], title: "Stat Definitions" },
	},
];

const routes = [
	{
		path: "/",
		name: "login",
		component: Login,
		meta: { auth: null, title: "Login" },
	},
	{
		path: "/login",
		name: "login",
		component: Login,
		meta: { auth: null, title: "Login" },
	},
	{
		path: "/password/reset/:token",
		name: "reset.password",
		component: ResetPassword,
		meta: { auth: null, title: "Reset Password" },
	},
	{
		path: "/forgot-password",
		name: "forgot.password",
		component: ForgotPassword,
		meta: { auth: null, title: "Forgot Password" },
	},
	{
		path: "/email-verify/:token",
		name: "verify.email",
		component: VerifyEmail,
		meta: { auth: null, title: "Verify Email" },
	},

	// base_layout
	{
		path: "/home",
		name: "base_layout",
		component: BaseLayout,
		children: baseLayoutRoutes,
	},

	{
		path: "*",
		name: "404",
		component: Error404,
		meta: { auth: null, title: "404" },
	},
];

const router = new VueRouter({
	history: true,
	mode: "history",
	routes,
});

router.beforeEach((to, from, next) => {
	setPageTitle(to.meta.title);
	next();
});

export default router;
